"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const Calibri_woff_1 = __importDefault(require("@/assets/fonts/Calibri.woff"));
const Calibri_woff2_1 = __importDefault(require("@/assets/fonts/Calibri.woff2"));
const Calibri_Bold_woff_1 = __importDefault(require("@/assets/fonts/Calibri-Bold.woff"));
const Calibri_Bold_woff2_1 = __importDefault(require("@/assets/fonts/Calibri-Bold.woff2"));
const Calibri_Italic_woff_1 = __importDefault(require("@/assets/fonts/Calibri-Italic.woff"));
const Calibri_Italic_woff2_1 = __importDefault(require("@/assets/fonts/Calibri-Italic.woff2"));
const Calibri_Light_woff_1 = __importDefault(require("@/assets/fonts/Calibri-Light.woff"));
const Calibri_Light_woff2_1 = __importDefault(require("@/assets/fonts/Calibri-Light.woff2"));
const Calibri_Light_Italic_woff_1 = __importDefault(require("@/assets/fonts/Calibri-Light-Italic.woff"));
const Calibri_Light_Italic_woff2_1 = __importDefault(require("@/assets/fonts/Calibri-Light-Italic.woff2"));
const Calibri_Bold_Italic_woff_1 = __importDefault(require("@/assets/fonts/Calibri-Bold-Italic.woff"));
const Calibri_Bold_Italic_woff2_1 = __importDefault(require("@/assets/fonts/Calibri-Bold-Italic.woff2"));
const theme = (0, styles_1.createTheme)({
    spacing: [0, 4, 8, 16, 32, 64, 128],
    shadows: [
        "none",
        "0px 1px 2px rgba(51, 51, 51, 0.1)",
        "0px 2px 4px rgba(51, 51, 51, 0.1)",
        "0px 4px 8px rgba(51, 51, 51, 0.1)",
        "0px 8px 16px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
        "0px 16px 32px rgba(51, 51, 51, 0.1)",
    ],
    typography: {
        fontFamily: "Calibri, Open Sans, sans-serif",
        h1: {
            fontWeight: "300",
            fontSize: 36,
            letterSpacing: "0.2px",
        },
        h2: {
            fontWeight: "500",
            fontSize: 32,
            letterSpacing: "0px",
        },
        h3: {
            fontWeight: "600",
            fontSize: 24,
            letterSpacing: "0.1px",
        },
        h4: {
            fontWeight: "500",
            fontSize: 18,
            letterSpacing: "0.2px",
        },
        h5: {
            fontWeight: "500",
            fontSize: 14,
            letterSpacing: "0.2px",
        },
        h6: {
            fontWeight: "300",
            fontSize: 12,
            letterSpacing: "0.2px",
        },
        subtitle1: {
            fontWeight: "500",
            fontSize: 16,
            letterSpacing: "0.1px",
        },
        subtitle2: {
            fontWeight: "500",
            fontSize: 14,
            letterSpacing: "0.1px",
        },
        body1: {
            fontWeight: "400",
            fontSize: 16,
            letterSpacing: "0.1px",
        },
        body2: {
            fontWeight: "400",
            fontSize: 14,
            letterSpacing: "0.1px",
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
        html, body {
          height: 100%
        }

        @font-face {
          font-family: 'Calibri';
          src: local('Calibri'), url(${Calibri_woff2_1.default}) format('woff2'),
            url(${Calibri_woff_1.default}) format('woff');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }

        @font-face {
          font-family: 'Calibri';
          src: local('Calibri Bold'), local('Calibri-Bold'),
            url(${Calibri_Bold_woff2_1.default}) format('woff2'),
            url(${Calibri_Bold_woff_1.default}) format('woff');
          font-weight: bold;
          font-style: normal;
          font-display: swap;
        }

        @font-face {
          font-family: 'Calibri';
          src: local('Calibri Italic'), local('Calibri-Italic'),
            url(${Calibri_Italic_woff2_1.default}) format('woff2'),
            url(${Calibri_Italic_woff_1.default}) format('woff');
          font-weight: normal;
          font-style: italic;
          font-display: swap;
        }

        @font-face {
          font-family: 'Calibri';
          src: local('Calibri Light'), local('Calibri-Light'),
            url(${Calibri_Light_woff2_1.default}) format('woff2'),
            url(${Calibri_Light_woff_1.default}) format('woff');
          font-weight: 300;
          font-style: normal;
          font-display: swap;
        }

        @font-face {
          font-family: 'Calibri';
          src: local('Calibri Light Italic'), local('Calibri-LightItalic'),
            url(${Calibri_Light_Italic_woff2_1.default}) format('woff2'),
            url(${Calibri_Light_Italic_woff_1.default}) format('woff');
          font-weight: 300;
          font-style: italic;
          font-display: swap;
        }

        @font-face {
          font-family: 'Calibri';
          src: local('Calibri Bold Italic'), local('Calibri-BoldItalic'),
            url(${Calibri_Bold_Italic_woff2_1.default}) format('woff2'),
            url(${Calibri_Bold_Italic_woff_1.default}) format('woff');
          font-weight: bold;
          font-style: italic;
          font-display: swap;
        }
      `,
        },
        MuiButton: {
            styleOverrides: {
                root: `          
          font-size: 14px;
          font-weight: bold;
          text-transform: none;
        `,
                containedPrimary: `
          color: #fff;
          background-color: #0057b8;
          &:hover {
            background-color: #00A9E0;
          }
          &:active {
            background-color: #0057b8;
          }
          &:focus {
            outline: 2px solid #00A9E0;
          }`,
                outlinedSecondary: `
          color: #333;
          outline: 1px solid #E0E0E0;
          border: none;
          background-color: #fff;
          &:hover {
            background-color: #fff;
            outline: 1px solid #BDBDBD;
            border: none;
          }
          &:active {
            outline: none;
            border: none;
          }
          &:focus {
            outline: 2px solid #00A9E0;
            background-color: #fff;
            border: none;
          }
        `,
                sizeSmall: `
          padding: 2px 4px;
        `,
                sizeMedium: `
          padding: 4px 8px;
        `,
                sizeLarge: `
          padding: 8px 16px;
        `,
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: `
          input {
            padding: 8px 10px;
          }
   
          fieldset {
            border-color: #E0E0E0;

            &:hover {
              border-color: #E0E0E0 !important;
            }
          }

          &.Mui-focused fieldset {
            border: 2px solid #00A9E0;
          }

          &.MuiFormHelperText-root.Mui-error {
            margin-left: 0;
          }
        `,
                notchedOutline: `
          border-color: #E0E0E0;
        `,
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: `        
          top: -16px;
          left: -13px;
          position: relative;
          font-weight: bold;  
          
          .&.Mui-focused {
            color: #333;
          }
        `,
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: `
          margin-left: 0;
          margin-top: 1px;
        `,
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: { paddingTop: 0, paddingBottom: 0 },
            },
        },
    },
    palette: {
        background: {
            default: "#F2F2F2;",
        },
        institutional: {
            braskemBlue: "#0057b8",
            braskemGray: "#425563",
            braskemCyan: "#00A9E0",
            braskemYellow: "#FFCD00",
            main: "#0057b8",
        },
        secondary: {
            braskemBlue: "#0057b8",
            braskemGray: "#425563",
            braskemCyan: "#00A9E0",
            main: "#005C8D",
            light: "#2886BF",
        },
        gradient: {
            blue: "linear-gradient(90deg, #0057B8 0%, #00A9E0 100%)",
        },
        grayScale: {
            white: "#FFFFFF",
            gray6: "#F2F2F2",
            gray5: "#E0E0E0",
            gray4: "#BDBDBD",
            gray3: "#828282",
            gray2: "#4F4F4F",
            gray1: "#333333",
        },
        support: {
            info: "#0057B8",
            success: "#00A9E0",
            error: "#E0004D",
            warning: "#FE5000",
        },
    },
});
exports.default = theme;
